import { Form, withFormik } from "formik";
import withName from "../../hoc/withName";
import { FormCropsSelector, FormRow, SelectRow } from "../Form/Form";
import { useTranslation, withTranslation } from "react-i18next";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import DivPortal from "../Utils/DivPortal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DialogComponentWrapper from "../Utils/DialogComponentWrapper";
import RestAPI from "@aws-amplify/api-rest";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { FarmContext } from "../../contexts/FarmContext";
import LoadingDialog from "../Utils/LoadingDialog";
import { validateSomething, validateString50 } from "../Form/Validations";
import { useColsEffect } from "../../utils/tables";
import SelfHelp from "../Utils/SelfHelp";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";

// nested table of states within specie configuration form
const EstadosFenologicosForm = ({ estados, setEstados, plantilla }) => {
    const estadosGrid = useRef(null);
    const [dialogState, setDialogState] = useState({ visible: false });
    const [selectedRow, setSelectedRow] = useState(null);
    const { t } = useTranslation();
    const nombreEstadoRef = useRef(null);
    const duracionEstadoRef = useRef(null);
    const [error, setError] = useState(null);

    const names = useMemo(() => [
        t("general.name"), t("farms.fenologia.duracion")
    ], [t]);

    // Save/Cancel Dialog Estados Fenologicos
    const buttons = useMemo(() => [
        {
            // Save
            click: (e) => {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    return false;
                }
                const newNombre = nombreEstadoRef.current.value.trim();
                const newDuracion = duracionEstadoRef.current.value;

                if (!newNombre) return;
                if (parseInt(newDuracion || 0, 10) < 1) {
                    setError({ duracion: true });
                    return;
                }

                // Edit row
                if (selectedRow){
                    const newEstado = {
                        ...selectedRow,
                        nombre: newNombre,
                        duracion: parseInt(newDuracion || 0, 10)
                    };
                    setEstados(oldEstados => {
                        return oldEstados.map((estado) => (estado.ordinal === selectedRow.ordinal ? newEstado : estado));
                    });
                } else {
                    const findEstado = estados?.find(e => e.nombre === newNombre);
                    if (findEstado) return;
                    const estadoAlreadyInPlantilla = plantilla?.estados_fenologicos?.find(e => e.nombre === newNombre);
                    // Create
                    setEstados(oldEstados => [...oldEstados, {
                        ordinal: estados ? estados.length + 1 : 1,
                        nombre: newNombre,
                        duracion: parseInt(newDuracion || 0, 10),
                        key_estado: estadoAlreadyInPlantilla?.key_estado || null
                    }]);
                }

                cleanForm();
            },
            buttonModel: { cssClass: "e-primary", content: t("forms.save"), isPrimary: true, disabled: false }
        },
        {
            // cancel
            click: () => cleanForm(),
            buttonModel: { cssClass: "e-flat", content: t("forms.cancel"), disabled: false }
        }
    ], [estados, plantilla?.estados_fenologicos, selectedRow, setEstados, t]);

    useColsEffect(estadosGrid, names);



    const changeDuracion = () => {
        if (duracionEstadoRef.current.value === "") return;
        if (duracionEstadoRef.current && duracionEstadoRef.current.value > 365) duracionEstadoRef.current.value = 365;
        if (duracionEstadoRef.current && duracionEstadoRef.current.value < 0) duracionEstadoRef.current.value = 0;
    };

    const cleanForm = () => {
        nombreEstadoRef.current.value = "";
        duracionEstadoRef.current.value = "";
        setDialogState({ visible: false });
        setSelectedRow(null);
        setError(null);
    };
    return (
        <>
            <DivPortal container="estadosTableToolbar">
                <FontAwesomeIcon className='btnEdit pointer text-dark' size="lg" icon={faPlus}
                    onClick={() => {
                        setDialogState({ visible: true });
                    }}
                />
            </DivPortal>
            {/* Edit/Create Estado Fenologico */}
            <DialogComponentWrapper
                animationSettings={{ effect: "Zoom", duration: 300, delay: 0 }}
                isModal
                visible={dialogState.visible}
                close={() => { cleanForm(); }}
                width='650px'
                height='30%'
                showCloseIcon
                header={t("farms.fenologia.estadosFenologicos")}
                buttons={buttons}
                t={t}
                dialogState={dialogState}
                setDialogState={setDialogState}
            >
                <div className="col-12 text-center">
                    <div className="row linea-formulario">
                        <div className="col-12 col-md-4 text-md-right mtem-05">
                            <label className='boldie'>{t("general.name")}</label>
                        </div>
                        <div className="mb-2 input-group col-md-8">
                            <div className="p-0">
                                <input id="nombre" name="nombre"
                                    ref={nombreEstadoRef}
                                    key={selectedRow?.nombre || ""}
                                    minLength={1}
                                    maxLength={50}
                                    defaultValue={selectedRow?.nombre || ""}
                                    placeholder={t("general.name")}
                                    className="form-control nombre-estado text-center text-md-left"
                                    type="string"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row linea-formulario">
                        <div className="col-12 col-md-4 text-md-right mtem-05">
                            <label className='boldie'>{t("farms.fenologia.duracion")}</label>
                        </div>
                        <div className="mb-2 input-group col-md-8">
                            <div className="p-0 unit-input-content">
                                <input id="duracion" name="duracion"
                                    ref={duracionEstadoRef}
                                    max={365} min={0} step={1}
                                    placeholder="0"
                                    key={selectedRow?.duracion || ""}
                                    defaultValue={selectedRow?.duracion || ""}
                                    onChange={changeDuracion}
                                    className="form-control text-center text-md-left"
                                    type="number"
                                />
                                <p className="unit-edit">{t("forms.dias")}</p>
                            </div>
                        </div>
                        {error?.duracion &&
            <div className="col-12 msgRawValidation">
                <span>{t("farms.fenologia.errorDuracion")}</span>
            </div>}
                    </div>
                </div>
            </DialogComponentWrapper>
            <DataTablePrime
                t={t}
                items={estados}
                size="small"
                reorderable
                reorderableRows onRowReorder={(e) => setEstados(e.value)}
                editableRow
                editFunction= {async (event, rowData) => {
                    setDialogState({ visible: true });
                    setSelectedRow(rowData);
                }}
                deletableRow
                deleteFunction= {async (event, rowData) => {
                    setEstados(oldEstados => {
                        const newEstados = oldEstados.filter(estado => estado.ordinal !== rowData.ordinal);
                        // update ordinal
                        return newEstados.map((estado, id) => ({ ...estado, ordinal: id + 1 }));
                    });
                }}
                fields={[
                    {field:"ordinal",header:"orden", bodyStyle:{textAlign:"center"}, hidden:true},
                    {field:"nombre",header:names[0], bodyStyle:{textAlign:"center"}},
                    {field:"duracion",header:names[1], bodyStyle:{textAlign:"center"}},
                ]}
            />
            <span>{t("farms.fenologia.totalDias")}: {estados?.reduce((sum, e) => sum + e?.duracion??0, 0)}</span>
        </>
    );
};

// main form when creating a specie configuration
const PhenologyForm = ({ plantilla, cultivos, t, paletas, values, cancel, handleSubmit, errors, setFieldValue, tiposRenovacion, especiesCampo } ) => {
    const [estados, setEstados] = useState(values?.estados_fenologicos);

    const { i18n } = useTranslation();

    useEffect(() => {
        setFieldValue("estados_fenologicos", estados);
    }, [estados, setFieldValue]);

    const phenologyFormHelpImages = {
        phenologyForm: import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-fenologia-form.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-farminfo-fenologia-form.png`],
        estadosTable: import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-fenologia-estadosTable.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-farminfo-fenologia-estadosTable.png`],
        estadosForm: import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-fenologia-estadosForm.png", { eager: true, import: "default" })[`../../img/autoayuda/${i18n.language}/autoayuda-farminfo-fenologia-estadosForm.png`]
    };

    const phenologyPropsParams = {
        header: t("selfHelp.farmInfo.properties"),
        definitionName: [
            t("general.name"),
            t("cultivos.especie"),
            t("cultivos.variedad"),
            t("farms.fenologia.paleta"),
            t("farms.fenologia.tipoRenovacion"),
        ],
        definitionText: [
            t("selfHelp.definitions.nombrePlantilla"),
            t("selfHelp.definitions.especieFenologia"),
            t("selfHelp.definitions.variedadFenologia"),
            t("selfHelp.definitions.paletaFenologia"),
            t("selfHelp.definitions.renovacionFenologia"),
        ]
    };

    const paletaSelectorTemplate = (props) => {
        return (
            <div className="d-flex">
                <div>
                    {props.nombre}:
                </div>
                <div className="d-flex ml-2 flex-wrap align-items-center justify-content-center">
                    {props.texto && props.texto.map((color, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: color, width: "1rem",
                                height: "1rem", margin: "2px", border: "1px solid #ccc",
                            }}
                        />
                    ))}
                </div>
            </div>
        );
    };

    useEffect(() => {
        if (!values?.cultivo_especie_id) setFieldValue("cultivo_variedad_id", null);
    }, [setFieldValue, values?.cultivo_especie_id]);

    return (
        <div className="card">
            <div className="card-body ">
                <Form id="phenology_form" onSubmit={handleSubmit}>
                    <div className="row">
                        <div className='col col-sm-2 col-md-3 col-lg-4'>
                            <SelfHelp t={t} target="PhenologyForm" images={phenologyFormHelpImages} params={phenologyPropsParams} lng={i18n.language} />
                        </div>
                        <div className="col col-sm-8 col-md-6 col-lg-4 text-center">
                            <h5 className="card-title">
                                {t("farms.fenologia.title")}
                            </h5>
                        </div>
                        <div className="col col-sm-2 col-md-3 col-lg-2 d-flex justify-content-end align-items-center" />
                    </div>
                    <div className="linea-titulo" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <FormRow
                                edit
                                dato1={values?.nombre}
                                nombre1={t("general.name")}
                                campo1="nombre"
                                error1={errors?.nombre && t(errors?.nombre)}
                            />
                            <FormCropsSelector
                                cultivos={cultivos}
                                sector={{}}
                                especieId={values?.cultivo_especie_id || ""}
                                variedadId={values?.cultivo_variedad_id || ""}
                                edit
                                showSubEspecie={false}
                                especiesCampo={especiesCampo}
                                showClearButton
                            />
                            <SelectRow
                                edit
                                nombre={t("farms.fenologia.paleta")}
                                campo="paletteId"
                                options={paletas}
                                error={errors.paletteId && t(errors.paletteId)}
                                optionKey="id"
                                optionLabel="nombre"
                                placeholder={t("farms.fenologia.paleta")}
                                itemTemplate={paletaSelectorTemplate}
                            />
                            <SelectRow
                                edit
                                nombre={t("farms.fenologia.tipoRenovacion")}
                                campo="tipo_renovacion"
                                options={tiposRenovacion}
                                error={errors.tipo_renovacion && t(errors.tipo_renovacion)}
                                optionKey="tipo"
                                optionLabel="nombre"
                                placeholder={t("farms.fenologia.tipoRenovacion")}
                            />
                            <div className="row justify-content-center">
                                <h6 style={{ marginTop: "10px" }}>
                                    {t("farms.fenologia.estadosFenologicos")}
                                </h6>
                            </div>
                            <div className="linea-titulo" />
                            <div className="row linea-formulario justify-content-end">
                                <div id="estadosTableToolbar"
                                    className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                                />
                            </div>
                            <EstadosFenologicosForm estados={estados} setEstados={setEstados} plantilla={plantilla} />
                            {errors.estados_fenologicos && t(errors.estados_fenologicos) ?
                                <div className="mb-2 col-12 d-block">
                                    <div className="alert alert-warning m-0" role="alert">{t("farms.fenologia.estadosFenologicos")}: {t("validation.required")}</div>
                                </div>
                                : null}
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "10px" }}>
                        <ButtonPrime onClick={cancel} label={t("forms.cancel")} small />
                        <ButtonPrime label={t("forms.save")} type="submit" small />
                    </div>
                </Form>
            </div>
        </div>
    );
};

const validateForm = (data) => {
    const errors = {};
    if (data) {
        for (const field of Object.keys(data)) {
            if (["paletteId", "tipo_renovacion"].includes(field)) {
                const er = validateSomething(data[field]);
                if (er !== undefined) errors[field] = er;
            } else if (field === "estados_fenologicos") {
                const er = data.estados_fenologicos?.length > 0 ? undefined : "validation.required";
                if (er !== undefined) errors[field] = er;
            } else if (field === "nombre") {
                const er = validateString50(data[field]);
                if (er !== undefined) errors[field] = er;
            }
        }
    }
    return errors;
};

const FormikForm = withFormik({
    mapPropsToValues: (props) => {
        const data = Object.assign({}, props.plantilla);
        if (data) {
            return {
                cultivo_especie_id: data.cultivo_especie_id,
                tipo_renovacion: data.tipo_renovacion,
                paletteId: props.paletas.find(p => {
                    return data.paleta_colores?.every((pc, idx) => pc === p.texto[idx]);
                })?.id,
                estados_fenologicos: data.estados_fenologicos || [],
                cultivo_variedad_id: data.cultivo_variedad_id,
                nombre: data.nombre
            };
        }
    },
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validate: validateForm,
    handleSubmit: (values, { props }) => {
        const newValues = {...values};
        newValues?.estados_fenologicos?.forEach((e,i) => {
            e.ordinal=i+1;
        });
        props.savePlantilla(newValues, props);
    }
})(withTranslation()(PhenologyForm));

const getPlantillaId = (location) => {
    const params = new URLSearchParams(location && location.search);
    return params.get("plantilla");
};

const Phenology = ({ dataFarm, sectorsInfo }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [cultivos, setCultivos] = useState(null);
    const [loading, setLoading] = useState(true);
    const [navigationReady, setNavigationReady] = useState(false);
    const [_, farmDispatch] = useContext(FarmContext);


    useEffect(() => {
        async function getCultivos() {
            try {
                const data = await RestAPI.get("apiAdminDropControl", `/farms/cultivos/${i18n.language || "en"}`);
                setCultivos(data);
            } catch (error) {
                console.log(error);
            }
            setLoading(false);
        }
        getCultivos();
    }, [i18n.language]);

    const plantillaSelected = useMemo(() => {
        const plantillaId = getPlantillaId(location);
        if (plantillaId) {
            return dataFarm.fenologia.find(p => p.plantilla_estado_fenologico_id === +plantillaId) || null;
        } else return null;
    }, [dataFarm.fenologia, location]);

    const farmSpeciesMap = useMemo(() => {
        const sectorsWithSpecie = sectorsInfo?.filter(sector => sector.cultivo_especie_id);
        return new Map(sectorsWithSpecie?.map(sector => [sector.cultivo_especie_id, sector.especie]));

    }, [sectorsInfo]);

    const palettes = useMemo(() => {
        return dataFarm?.paletasFenologia?.map((p) => {
            return { nombre: t("farms.fenologia.paletaN", { id: p.id }), id: p.id, texto: p.palette };
        });
    }, [t]);

    const tiposRenovacion = useMemo(() => {
        return dataFarm?.tiposRenovacion?.map(tipo => ({ tipo, nombre: t(`farms.fenologia.tiposRenovacion.${tipo}`, "-") }));
    }, [dataFarm?.tiposRenovacion, t]);

    const cancel = () => {
        const newSearch = `?farm=${dataFarm.campo_id}`;
        navigate({ pathname: "/farms", search: newSearch });
    };

    useEffect(() => {
        if (navigationReady){
            const newSearch = `?farm=${dataFarm.campo_id}`;
            navigate({ pathname: "/farms", search: newSearch });
        }
    }, [dataFarm, navigate, navigationReady]);

    const savePlantilla = async (values) => {
        setLoading(true);
        const isUpdate = Boolean(plantillaSelected);
        const isCreate = !isUpdate;

        try {
            const payload = {
                nombre: values.nombre,
                cultivo_especie_id: values.cultivo_especie_id || null,
                cultivo_variedad_id: values.cultivo_variedad_id || null,
                paleta_colores: values.paletteId ? dataFarm.paletasFenologia.find(p => p.id === values.paletteId)?.palette : 1,
                tipo_renovacion: values.tipo_renovacion,
                estados_fenologicos: values.estados_fenologicos || []
            };
            if (isCreate) {
                const endpoint = `/farms/${dataFarm.campo_id}/plantillaFenologia/crear`;
                const data = await RestAPI.post("apiAdminDropControl", endpoint, { body: payload });
                const newFenologia = [ ...dataFarm.fenologia, {
                    ...payload,
                    plantilla_estado_fenologico_id: data.plantilla_estado_fenologico_id,
                    estados_fenologicos: data.estados_fenologicos,
                    especie: data.especie,
                    variedad: data.variedad
                }
                ];
                farmDispatch({ type: "set", params: ds => ({
                    ...ds,
                    original: { ...ds.original },
                    formated: false,
                    dataFarm: { ...dataFarm, fenologia: newFenologia } }) });
            } else if (isUpdate){
                const endpoint = `/farms/${dataFarm.campo_id}/plantillaFenologia/${plantillaSelected.plantilla_estado_fenologico_id}/editar`;
                const data = await RestAPI.post("apiAdminDropControl", endpoint, { body: payload });
                if (data.noChanges){
                    toast.info(t("forms.toastInfo"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
                    setLoading(false);
                    return;
                }
                farmDispatch({ type: "set", params: ds => {
                    return {
                        ...ds,
                        original: { ...ds.original },
                        formated: false,
                        dataFarm: {
                            ...dataFarm,
                            fenologia: dataFarm.fenologia.map(curPlantilla => {
                                return (curPlantilla.plantilla_estado_fenologico_id === plantillaSelected.plantilla_estado_fenologico_id)
                                    ?
                                    {
                                        ...payload,
                                        plantilla_estado_fenologico_id: plantillaSelected.plantilla_estado_fenologico_id,
                                        estados_fenologicos: data.estados_fenologicos,
                                        especie: data.especie,
                                        variedad: data.variedad
                                    }
                                    : curPlantilla;
                            })
                        }
                    };
                }});
            }
            toast.success(t("forms.toastSuccess"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            setLoading(false);
            setNavigationReady(true);
        } catch (error) {
            toast.error(t("forms.toastError"), { position: toast.POSITION.TOP_RIGHT, autoClose: 6000 });
            setLoading(false);
        }
    };

    return (
        <div className="row-container">
            {loading === true && <LoadingDialog />}
            {
                !Array.isArray(cultivos)
                    ? ""
                    : (
                        <FormikForm savePlantilla={savePlantilla} plantilla={plantillaSelected} allPlantillas={dataFarm.fenologia}
                            cultivos={cultivos} especiesCampo={farmSpeciesMap} paletas={palettes} cancel={cancel} tiposRenovacion={tiposRenovacion}
                        />
                    )
            }
        </div>
    );
};

export default withName(Phenology, "PhenologyFrag");
